const DEFAULT_MIME_TYPES = [
  'video/webm;codecs=vp8',
  'video/webm',
  'video/mp4;codecs=h264,aac',
  'video/mp4'
];

function parseResolution(resolution = '1920x1080') {
  const [width, height] = String(resolution).split('x').map((value) => Number(value));

  if (!Number.isFinite(width) || !Number.isFinite(height)) {
    return { width: 1920, height: 1080 };
  }

  return { width, height };
}

export function getSupportedRecordingMimeType(preferredMimeType) {
  const candidates = [
    ...(preferredMimeType ? [preferredMimeType] : []),
    ...DEFAULT_MIME_TYPES
  ].filter(Boolean);

  return [...new Set(candidates)].find((type) => MediaRecorder.isTypeSupported(type)) || '';
}

export async function openCamera(videoElement, facingMode = 'environment', settings = {}) {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('Trinh duyet khong ho tro camera');
  }

  const { width, height } = parseResolution(settings.resolution);
  const frameRate = Number(settings.frameRate) || 30;
  const audioEnabled = Boolean(settings.audioEnabled);
  const preferredVideo = {
    facingMode: { ideal: facingMode },
    width: { ideal: width },
    height: { ideal: height },
    frameRate: { ideal: frameRate, max: frameRate }
  };

  let stream;

  try {
    stream = await navigator.mediaDevices.getUserMedia({
      video: preferredVideo,
      audio: audioEnabled
        ? {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true
          }
        : false
    });
  } catch (error) {
    console.warn('Khong mo duoc camera uu tien, dang thu camera mac dinh', error);
    stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: audioEnabled
    });
  }

  if (videoElement) {
    videoElement.srcObject = stream;
    await videoElement.play().catch(() => {});
  }

  return stream;
}

export function stopCameraStream(stream, videoElement) {
  stream?.getTracks().forEach((track) => track.stop());

  if (videoElement) {
    videoElement.srcObject = null;
  }
}
